import type { JSX } from 'react';
import type { HolterSecondRoundAnswerData } from '@common/validation/customControls/cardiology/holter/holterSecondRoundAnswerSchemas';
import { CustomControlCode } from '@common/enums';
import { useProcessActivityReadContext } from '@frontend/utils';
import { AdditionalQuestionRead } from '../../../additionalQuestionAndAnswer/AdditionalQuestionRead';

export function HolterSecondRoundAnswerRead(): JSX.Element {
    const { processActivity } = useProcessActivityReadContext<HolterSecondRoundAnswerData>();

    return (
        <AdditionalQuestionRead
            customControlCode={CustomControlCode.HolterSecondRoundAnswer}
            message={processActivity.customControlData.bericht}
        />
    );
}
